/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `no_evidence` - No Evidence * `present` - Present * `absent` - Absent * `left` - Left
 */
export type AttendanceStatusEnum = 'no_evidence' | 'present' | 'absent' | 'left';

export const AttendanceStatusEnum = {
    NoEvidence: 'no_evidence' as AttendanceStatusEnum,
    Present: 'present' as AttendanceStatusEnum,
    Absent: 'absent' as AttendanceStatusEnum,
    Left: 'left' as AttendanceStatusEnum
};